import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
} from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  NgbModule,
  NgbCarouselConfig,
  NgbModalConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFireFunctionsModule, REGION } from 'angularfire2/functions';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AuthGuard } from './_guards/auth.guard';
import { AlertComponent } from './_directives/alert.component';
import { AlertService } from './_services/alert.service';
import { AuthService } from './_services/auth.service';
import { UserService } from './_services/user/user.service';
import { DataTablesModule } from 'angular-datatables';
import { HelperService } from './_services/helper/helper.service';
import { HotelService } from './_services/hotel/hotel.service';
import { CorporateService } from './_services/corporate/corporate.service';
import { AdminService } from './_services/admin/admin.service';
import { ArchwizardModule } from 'angular-archwizard';
// import {MatIconModule} from '@angular/material/icon';
// import { NgSelectModule } from '@ng-select/ng-select';
// import { CarouselModule } from 'ngx-owl-carousel-o';
import { SliderModule } from 'ngx-slider';

import { ToastrModule } from 'ngx-toastr';
// Routing
import { routing } from './app.routing';

// Components
import { AppComponent } from './app.component';

import { SettingsModule } from './_layout/settings/settings.module';
import { ThemeSettingsConfig } from './_layout/settings/theme-settings.config';
import { MenuSettingsConfig } from './_layout/settings/menu-settings.config';

import { HeaderComponent } from './_layout/header/header.component';
import { VerticalComponent as HeaderVerticalComponent } from './_layout/header/vertical/vertical.component';
import { HorizontalComponent as HeaderHorizontalComponent } from './_layout/header/horizontal/horizontal.component';
import { FullLayoutNavbarComponent } from './_layout/header/full-layout-navbar/full-layout-navbar.component';

import { FooterComponent } from './_layout/footer/footer.component';
import { NavigationComponent as AppNavigationComponent } from './_layout/navigation/navigation.component';

import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';

import { RegisterComponent } from './register';
import { SocialSigninComponent } from './social-signin/social-signin.component';
import { LoginComponent } from './login';
import { Login2Component } from './login2';

import { ChangelogComponent } from './changelog/changelog.component';

import { NavbarService } from './_services/navbar.service';
import { VerticalnavComponent } from './_layout/navigation/verticalnav/verticalnav.component';
import { HorizontalnavComponent } from './_layout/navigation/horizontalnav/horizontalnav.component';

// perfect scroll bar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { DeviceDetectorModule } from 'ngx-device-detector';
import { RouterModule } from '@angular/router';
import { CustomizerComponent } from './_layout/customizer/customizer.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PartialsModule } from './content/partials/partials.module';
import { BreadcrumbModule } from './_layout/breadcrumb/breadcrumb.module';
import { DataApiService } from './_services/data.api';
import { UploadBillService } from './_services/upload-bill.service';

import { HorizontalCustomizerComponent } from './_layout/customizer/horizontal-customizer/horizontal-customizer.component';
import { BlockTemplateComponent } from './_layout/blockui/block-template.component';
import { BlockUIModule } from 'ng-block-ui';
import { MatchHeightModule } from './content/partials/general/match-height/match-height.module';
import { FullLayoutComponent } from './_layout/full-layout/full-layout.component';
import { ShowForModule } from './content/partials/general/show-for/show-for.module';
import { SharedModule } from './shared/shared.module';
import { BookingHistoryComponent } from './shared/booking-history/booking-history.component';
import { TravelPolicyComponent } from './shared/travel-policy/travel-policy.component';
import { FlightActivityComponent } from './shared/activity-details/flight-activity/flight-activity.component';
import { TrainBusActivityComponent } from './shared/activity-details/train-bus-activity/train-bus-activity.component';
import { CabActivityComponent } from './shared/activity-details/cab-activity/cab-activity.component';
import { FoodActivityComponent } from './shared/activity-details/food-activity/food-activity.component';
import { MealsActivityComponent } from './shared/activity-details/meals-activity/meals-activity.component';
import { MeetingsActivityComponent } from './shared/activity-details/meetings-activity/meetings-activity.component';
import { OthersActivityComponent } from './shared/activity-details/others-activity/others-activity.component';
import { PriceBreakupComponent } from './shared/price-breakup/price-breakup.component';
import { MatDialogModule, MatDialogRef  } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DialogPaymentGatewayComponent } from './dialog-payment-gateway/dialog-payment-gateway.component';
import {MatButtonModule} from '@angular/material/button';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    BrowserModule,
    PartialsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatchHeightModule,
    ShowForModule,
    SharedModule,
    BreadcrumbModule,
    NgbModule,
    ArchwizardModule,
    // NgSelectModule,
    SliderModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireFunctionsModule,
    AngularFireStorageModule,
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features
    routing,
    ToastrModule.forRoot(),
    DataTablesModule,
    // Settings modules
    SettingsModule.forRoot(ThemeSettingsConfig, MenuSettingsConfig),
    PerfectScrollbarModule,
    NgxSpinnerModule,
    DeviceDetectorModule.forRoot(),
    LoadingBarRouterModule,
    MatDialogModule,
    MatTooltipModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent,
    }),
  ],
  declarations: [
    AppComponent,
    PublicLayoutComponent,
    PrivateLayoutComponent,
    HeaderComponent,
    FullLayoutNavbarComponent,
    HeaderHorizontalComponent,
    HeaderVerticalComponent,
    FooterComponent,
    AppNavigationComponent,
    AlertComponent,
    RegisterComponent,
    SocialSigninComponent,
    LoginComponent,
    Login2Component,
    ChangelogComponent,
    VerticalnavComponent,
    HorizontalnavComponent,
    CustomizerComponent,
    HorizontalCustomizerComponent,
    BlockTemplateComponent,
    FullLayoutComponent,
    BookingHistoryComponent,
    PriceBreakupComponent,
    TravelPolicyComponent,
    FlightActivityComponent,
    TrainBusActivityComponent,
    CabActivityComponent,
    FoodActivityComponent,
    MealsActivityComponent,
    MeetingsActivityComponent,
    OthersActivityComponent,
    DialogPaymentGatewayComponent
  ],
  providers: [
    { provide: REGION, useValue: 'asia-southeast1' },
    // { provide: USE_EMULATOR, useValue: ['localhost', 5001] },
    AuthGuard,
    AlertService,
    NavbarService,
    DataApiService,
    UserService,
    HelperService,
    HotelService,
    CorporateService,
    AdminService,
    AuthService,
    UploadBillService,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerGestureConfig,
    },
    NgbCarouselConfig,
    NgbModalConfig,
  ],
  entryComponents: [
    BlockTemplateComponent,
    BookingHistoryComponent,
    PriceBreakupComponent,
  ],
  bootstrap: [AppComponent],
  exports: [RouterModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {}
